import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import rotasStore from '../../../../store'

import { validateData, validateComputed } from '../_validates/validateAtivarDesativarRegex'

export const ativarDesativarAcaoMixins = {
  data: () => ({
    rotas: [],
    rotasParaMontarRegex: [],
    regex_id: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('ativarDesativarAcaoMixinStore', ['getRotas']),
    ...validateComputed,

    buscaRegex() {
      let regex = []

      const indexRota = this.rotas.findIndex(rota => rota.value === this.form.acao.rota_id)

      if (indexRota !== -1) {
        this.rotasParaMontarRegex[indexRota].regex.forEach(regexRota => {
          if (typeof regexRota.acao.description !== 'undefined') {
            regex.push({
              text: `${regexRota.prioridade} - ${regexRota.acao.description}`,
              value: regexRota.regex_id,
            })
          } else {
            regex.push({ text: `${regexRota.prioridade} - Sem descrição`, value: regexRota.regex_id })
          }
        })
      }
      return regex
    },
  },

  async created() {
    registerVuexModule(this.$store, 'ativarDesativarAcaoMixinStore', rotasStore)
  },

  methods: {
    ...mapActions('ativarDesativarAcaoMixinStore', ['listarRotas']),

    getItemsSelectRotas() {
      this.rotas = this.getRotas.map(rota => ({ text: rota.description, value: rota._id }))
    },
  },
}
